<template>
  <section class="py-5">
    <div class="container">
      <div class="d-flex align-items-start">
        <AccountOpes />
        <div class="aiz-user-panel">
          <div class="aiz-titlebar mt-2 mb-4">
            <div class="row align-items-center">
              <div class="col-md-6">
                <h1 class="h3">{{ $t("管理个人资料") }}</h1>
              </div>
            </div>
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0 h6">{{ $t("提款密码") }}</h5>
            </div>
            <div class="card-body">
              <van-form @submit="submit" label-width="120px">
                <van-field class="px-0"
                  v-model="oldPwd"
                  :label="$t('old_password')"
                  :placeholder="$t('old_password')"
                  :rules="[
                    { required: true, message: $t(`please_input`) },
                    {
                      pattern: /^.{4,16}$/,
                      message: $t('withdraw_password_format_error'),
                      trigger: 'blur'
                    }
                  ]"
                  type="password"
                />
                <van-field class="px-0"
                  v-model="newPwd"
                  :label="$t('new_password')"
                  :placeholder="$t('new_password')"
                  :rules="[
                    { required: true, message: $t(`please_input`) },
                    {
                      pattern: /^.{4,16}$/,
                      message: $t('withdraw_password_format_error'),
                      trigger: 'blur'
                    }
                  ]"
                  type="password"
                />
                <van-field class="px-0"
                  v-model="rePwd"
                  :label="$t('确认密码')"
                  :name="$t('确认密码')"
                  :placeholder="$t('确认密码')"
                  :rules="[
                    {
                      required: true,
                      message: $t(`please_input_confirm_password`)
                    },
                    {
                      pattern: /^.{4,16}$/,
                      message: $t('withdraw_password_format_error'),
                      trigger: 'blur'
                    }
                  ]"
                  type="password"
                />
                <div class="form-group text-right">
                  <van-button
                    :loading="loading"
                    :loading-text="$t('submitting')"
                    native-type="submit"
                    small
                    type="primary"
                  >
                    {{ $t("submit") }}
                  </van-button>
                </div>
              </van-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import AccountOpes from "@/components/AccountOpes.vue";

export default {
  components: { AccountOpes },
  data() {
    return {
      loading: false,
      oldPwd: null,
      newPwd: null,
      rePwd: null
    };
  },
  methods: {
    submit() {
      if (this.newPwd !== this.rePwd) {
        this.$toast.fail(this.$t("confirm_password_error"));
        return;
      }
      this.loading = true;
      this.$post("/user/updateTkPassword", {
        oldPwd: this.oldPwd,
        newPwd: this.newPwd
      })
        .then(() => {
          this.loading = false;
          this.$toast.success(this.$t("save_success"));
          this.$router.back();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
